<script>
    // @ts-nocheck
    import { Router, Route, navigate, useLocation } from 'svelte-navigator'
    import { fly, fade, slide } from 'svelte/transition'
    import searchlogo from '../assets/pictures/search.svg'
    import {
        clickOutside,
        sortBy,
        formatCUIT,
        areasOrder,
        isPdf,
    } from '$lib/utils'
    import {
        buildFilterCompilator,
        isoDateFilterTimestamp,
        multiKeyFilter,
    } from '$lib/services/dynamicFilters'
    import { API_URL, ENV } from '$lib/conf'
    import dictionaries from '$lib/stores/dictionaries'
    import user from '$lib/stores/user'
    import { writable } from 'svelte/store'
    import provider from '$lib/stores/provider'
    import waitingDocuments from '$lib/stores/countWaiting'
    import { currencyFormatter } from '$lib/utils'
    import { onMount, onDestroy } from 'svelte'
    import { Invoice } from '$lib/services/interfaces'
    import { db } from '$lib/services/db'
    import { liveQuery } from '$lib/services/livequery'
    import TopBar from '$lib/components/layout/TopBar.svelte'
    import {
        Banner,
        ScrollBox,
        Typography,
        TertiaryButton,
        FormBoxContainer,
        Datatable,
        FormBoxRow,
        FormBoxCell,
        BackDrop,
        SelectX,
        Row,
        Column,
        InputFile,
        InputText,
        InputTag,
        Alert,
        Spinner,
        Skeleton,
        Paginator,
        Chip,
        Button,
    } from '$lib/components/UI/'
    import InputDate from '$lib/components/UI/InputDate.svelte'
    import { SyncOutline } from '$lib/components/Icons'
    import { default as filterIcon } from '../assets/pictures/f28-filter-funnel.svg'
    import { default as notFoundDoc } from '../assets/pictures/f64-printer.svg'
    import Docs from '$lib/components/Icons/custom/Docs.svelte'
    import Upload from '$lib/components/Icons/custom/Upload.svelte'
    import Close from '$lib/components/Icons/custom/Close.svelte'
    import InvoiceTableHeader from '$lib/custom/components/InvoiceTableHeader.svelte'
    let dynamicFilter = [] // Arreglo de tuplas [assert<Bool>, filter<Function>]
    let showFilters = false
    let dataFilter = {
        id: '',
        fc_desde: 0,
        'source.organizeImports': true,
        fc_hasta: 0,
    }
    let siteUrl = ENV.API_URL.split('/').slice(0, -1).join('/')
    const company = {
        '1000': 'CAJA DE SEGUROS SA',
        '1001': 'RITENERE SA',
        '1002': 'CAJA DE AHORRO Y SEGURO SA',
        '3050101001': 'UNKNOW',
    }
    let currentPage
    function getDate(date, type = 'locale') {
        if (typeof date === 'number') {
            let tmpDate = new Date(date * 1000)
            if (type === 'locale') {
                return `${String(tmpDate.getDate()).padStart(2, '0')}/${String(tmpDate.getMonth() + 1).padStart(2, '0')}/${tmpDate.getFullYear()}`
            } else if (type === 'iso') {
                return `${tmpDate.getFullYear()}-${String(tmpDate.getMonth() + 1).padStart(2, '0')}-${String(tmpDate.getDate()).padStart(2, '0')}`
            } else {
                return ''
            }
        } else {
            return ''
        }
    }
    const refStates = {
        Ingresada: { alt: 'Factura ingresada', color: '#6F7072', icon: '' },
        'En tramite': {
            alt: 'Factura en trámite de aprobación, está siendo procesada.',
            label: 'En trámite',
            color: '#FF9F00',
            icon: '',
        },
        Rechazado: {
            alt: 'La factura fué rechazada.',
            label: 'Rechazada',
            color: '#AF2219',
            icon: '',
        },
        'En liquidacion': {
            alt: 'En proceso de liquidación.',
            label: 'En liquidación',
            color: '#FF9F00',
            icon: '',
        },
        Aprobada: {
            alt: 'Su pago fué aprobado.',
            color: '#7ED321',
            icon: '',
        },
        'Fondos Transferidos': {
            alt: 'El pago de la factura ha sido realizado.',
            color: '#7ED321',
            icon: '',
        },
    }
    let sortDirective = writable(['fecha_creacion'])
    const invoices = liveQuery(db.invoices, Invoice)
    const location = useLocation()
    const getRegex = (v, f = '') => {
        return new RegExp(v, f)
    }
    const filterCompilator = buildFilterCompilator((t) =>
        t.where('cuit').equals($user?.defaultAccount)
    )
    function search(val) {
        currentPage = 1
        dynamicFilter = [
            [
                true, //   Assert (default search)
                (f) =>
                    f.filter((item) => {
                        // Custom filter (default search)
                        return (
                            [
                                'ref',
                                'id_ath',
                                'estado',
                                'nro_comprobante',
                                'importe_total',
                            ].some((x) =>
                                getRegex(
                                    `${val.replace(/[^\x00-\x7F]+/g, '.')}`,
                                    'i'
                                ).test(item[x])
                            ) ||
                            getRegex(val).test(getDate(item.fecha_creacion))
                        )
                    }),
            ],
        ]
        if (val == '') {
            clearFilter()
        }
    }
    let inputValue = ''
    let isValidAttachment = false
    $: visible = $location.pathname !== '/home/invoices'
    const clearFilter = (_) => {
        inputValue = ''
        dynamicFilter = [] // clear filters
    }
    const autorefresh = setInterval((_) => {
        invoices.sync()
    }, 300000)

    onMount((_) => {
        autorefresh
        setTimeout((_) => {
            invoices.sync()
        }, 1500)
        return () => clearInterval(autorefresh)
    })

    // onDestroy((_) => {
    //     clearInterval(autorefresh)
    // })
    let dataForm = {}
    $: if ($provider || dataForm) {
        dataForm.email = $provider.data.email_dp
    }

    function sendInvoice() {
        Invoice.add(dataForm)
            .then(async (r) => {
                waitingDocuments.append(-1)
                if (r.ok) {
                    let item = await r.json()
                    invoices.add(item).then((r) => {
                        console.log('Promise Collection')
                    })
                    return r
                } else {
                    throw new Error('Falla al subir factura')
                }
            })
            .catch((_) => waitingDocuments.append(-1))
        waitingDocuments.append(1)
        clearForm()
    }
    let validOC = true
    let ocInp = ''
    let paginatorObj = {}
    $: if (showFilters === true) {
        dynamicFilter = [
            multiKeyFilter(dataFilter?.id || '', ['id_ath', 'ref']),
            isoDateFilterTimestamp(
                [dataFilter?.fc_desde || null, dataFilter?.fc_hasta || null],
                'fecha_creacion'
            ),
        ]
    }
    // $: dynamicFilter = [
    //         multiKeyFilter(dataFilter.id || '', ['id_ath', 'ref']),
    //         isoDateFilterTimestamp([dataFilter?.fc_desde || null, dataFilter?.fc_hasta || null], 'fecha_creacion')
    // ];
    // $: if(`${JSON.stringify(dynamicFilter)}`){
    //     currentPage = 1;
    // };
    function getInvoiceId() {
        return Array(8)
            .fill('')
            .map(() => String.fromCharCode(32 + Math.ceil(Math.random() * 94)))
            .join('')
    }
    let invoiceId = getInvoiceId()
    function clearForm() {
        console?.clear && console.clear()
        dataForm = {}
        invoiceId = getInvoiceId()
    }
    $: areasList =
        $dictionaries?.areas?.sort((a, b) => {
            let x = areasOrder.indexOf(a?.label)
            let y = areasOrder.indexOf(b?.label)
            return x > y ? 1 : -1
        }) || []
    $: if (showFilters === false) {
        clearFilter()
    }
    $: invoices.liveQuery(filterCompilator(dynamicFilter, $sortDirective)) // Reactive filter
    $: validInvoiceData =
        Object.entries(dataForm).every(([k, x]) => {
            return (x && x.length > 0) || k === 'orden_de_compra'
        }) && isValidAttachment;
    // $: console.log({isValidAttachment, dataForm, validInvoiceData})
    // $: if (dataForm) {
    //     console?.clear && console.clear()
    //     console.log(JSON.stringify(dataForm, null, 4))
    //
</script>

<div
    style="width: 100%; padding: 50px 70px; display: flex; flex-direction:column; align-items: center; gap: 20px; position: relative"
>
    <Router primary={false}>
        <FormBoxContainer title="Subir Factura" icon={Upload}>
            {#key invoiceId}
                <span
                    style="display: flex; gap: 14px;width: 100%; flex-direction: column; padding:25px; position: relative;"
                >
                    <Row>
                        <Column>
                            <SelectX
                                required
                                bind:value={dataForm.area}
                                label="Área"
                                options={areasList}
                            />
                            <span
                                style="width: 100%;flex-wrap:wrap; display: flex; flex-direction: row; gap: 15px"
                            >
                                <InputTag
                                    validation={(v) =>
                                        v.match(/^4[5,7][0-9]{8}$/)}
                                    bind:valid={validOC}
                                    placeholder="Ingrese su OC (Ej: 4XXXXXXXXX + Enter)"
                                    bind:value={dataForm.orden_de_compra}
                                    bind:inputValue={ocInp}
                                    label="Órdenes de compra"
                                >
                                    <span
                                        slot="empty"
                                        style="color: var(--color-grey-300);width: 100%; text-align: center"
                                        >Sin órdenes de compra</span
                                    >
                                </InputTag>
                                {#if !validOC && ocInp}
                                    <Alert type="error"
                                        >La orden de compra debe comenzar con 45
                                        o 47 y estar formada por 10 dígitos
                                        numéricos.</Alert
                                    >
                                {/if}
                            </span>
                        </Column>
                        <Column style="height: 100%">
                            <SelectX
                                required
                                bind:value={dataForm.tipo}
                                label="Clase de documento"
                                options={sortBy(
                                    $dictionaries.clasedocumentosap || [],
                                    ['-label']
                                )}
                            />
                            <InputFile
                                style="text-align: center; height: 100%"
                                bind:value={dataForm.file}
                                bind:valid={isValidAttachment}
                                validation={(d) =>
                                    d instanceof Array &&
                                    d.length > 0 &&
                                    d.every((f) => isPdf(f?.filename) || false)}
                                errMsg="Por favor cargue un documento en formato PDF"
                                endpoint={`${API_URL}/upload`}
                            />
                        </Column>
                    </Row>
                    <Row justify="flex-end">
                        <Button
                            size="small"
                            disabled={!validInvoiceData}
                            on:click={sendInvoice}
                            label="Subir"
                        />
                    </Row>
                </span>
            {/key}
        </FormBoxContainer>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <FormBoxContainer title="Mis Facturas" icon={Docs}>
            <svelte:fragment slot="option">
                <!-- <img width="32px" src={filterIcon} alt=""> -->
                <span
                    on:click={(_) =>
                        invoices.sync({ cuit: $user?.defaultAccount })}
                    title="Sincronizar"
                >
                    <SyncOutline size={25} />
                </span>
                <span on:click={(_) => (showFilters = !showFilters)}>
                    {#if !showFilters}
                        <img
                            src={filterIcon}
                            title="Filtros"
                            width="25px"
                            alt="Filtros"
                        />
                    {:else}
                        <Close color="#C5281C" />
                    {/if}
                </span>
            </svelte:fragment>
            {#await invoices.init()}
                <span
                    style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
                >
                    <Spinner />
                </span>
            {:then _}
                {#if showFilters}
                    <span style="padding: 24px">
                        <Typography type="subhead">Identificador</Typography>
                        <Row>
                            <InputText
                                on:keyup={(_) => (currentPage = 1)}
                                bind:value={dataFilter.id}
                            />
                        </Row>
                        <Typography type="subhead">Fecha de creación</Typography
                        >
                        <Row>
                            <InputDate
                                on:change={(_) => (currentPage = 1)}
                                label="Desde"
                                bind:value={dataFilter.fc_desde}
                            />
                            <InputDate
                                on:change={(_) => (currentPage = 1)}
                                label="Hasta"
                                bind:value={dataFilter.fc_hasta}
                            />
                        </Row>
                        {#if !([dataFilter.fc_desde, dataFilter.fc_hasta].every((t) => t !== undefined && typeof t === 'string' && t !== '') && dataFilter.fc_hasta.localeCompare(dataFilter.fc_desde) !== -1)}
                            <Alert type="error"
                                >"Hasta" debe ser posterior a "Desde"</Alert
                            >
                        {/if}
                        <p>
                            Resultados totales: <strong
                                >{$invoices.length}</strong
                            >
                        </p>
                        <!-- <Chip color="grey">Resultados totales: {$invoices.length}</Chip> -->
                    </span>
                {:else}
                    <span class="search">
                        <img src={searchlogo} alt="" draggable="false" />
                        <input
                            type="search"
                            placeholder="Buscar"
                            bind:value={inputValue}
                            on:input={(_) => search(inputValue)}
                        />
                    </span>
                {/if}
                <Datatable
                    data={invoices}
                    bind:pagination={paginatorObj}
                    bind:currentPage
                    waitingSignals={waitingDocuments}
                >
                    <svelte:fragment slot="header">
                        <InvoiceTableHeader bind:sortDirective />
                    </svelte:fragment>
                    <svelte:fragment slot="body" let:item={invoice}>
                        <tr>
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    >{invoice.ref.match(/[0]{13}/)
                                        ? '...'
                                        : invoice.ref}</Typography
                                ></td
                            >
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    >{getDate(
                                        invoice.fecha_creacion
                                    )}</Typography
                                ></td
                            >
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    >{invoice.importe_total > 0
                                        ? currencyFormatter({
                                              n: invoice.importe_total,
                                              lang: 'es-AR',
                                              type: 'ARS',
                                          })
                                        : '...'}</Typography
                                ></td
                            >
                            <td
                                ><Chip
                                    label={invoice.estado}
                                    {...refStates[invoice.estado]}
                                /></td
                            >
                            <td
                                ><Typography
                                    style="margin: 0; padding: 0"
                                    type="body"
                                    color="grey-800"
                                    ><TertiaryButton
                                        on:click={(_) =>
                                            navigate(`invoices/${invoice.id}`, {
                                                state: {
                                                    ref: '/home/invoices',
                                                },
                                            })}
                                        label="Ver detalle"
                                    /></Typography
                                ></td
                            >
                        </tr>
                    </svelte:fragment>
                    <svelte:fragment slot="skeleton">
                        <tr
                            in:slide
                            class="row"
                            title="La información sera visible pronto"
                        >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px; max-width: 145px"
                                /></td
                            >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px; max-width: 95px"
                                /></td
                            >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px"
                                /></td
                            >
                            <td
                                ><Skeleton
                                    style="opacity: 0.80; height: 21px; max-width: 80px"
                                /></td
                            >
                            <td
                                ><TertiaryButton
                                    label="Ver detalle"
                                    disabled
                                /></td
                            >
                        </tr>
                    </svelte:fragment>
                    <svelte:fragment slot="noContent">
                        <img
                            src={notFoundDoc}
                            height="75px"
                            alt=""
                            style="margin: 0;padding:0; width: auto"
                        />
                        <Typography style="margin: 0; padding: 0" type="body"
                            >No se encontraron Facturas.</Typography
                        >
                    </svelte:fragment>
                </Datatable>
            {/await}
        </FormBoxContainer>
        {#if ($invoices || []).length > 0}
            <Paginator {...paginatorObj} bind:currentPage />
        {/if}
        <Route path="/:id" let:params>
            <BackDrop style="z-index: 999999; position: fixed" {visible}>
                <div
                    class="drawer"
                    transition:fly={{ x: 50 }}
                    use:clickOutside
                    on:clickout={(_) => navigate('/home/invoices')}
                >
                    <TopBar
                        title="Detalle de Factura"
                        on:back={(_) => navigate($location?.state?.ref || -1)}
                    >
                        {#await invoices.get(params.id)}
                            <Spinner />
                        {:then invoice}
                            <div
                                transition:fade|local
                                style="position: absolute;width: 100%; height: 100%; display: flex; flex-direction: column; position: relative"
                            >
                                <Banner
                                    title={invoice.id_ath}
                                    label="factura"
                                    style=""
                                    info={[
                                        {
                                            label: 'CUIT',
                                            value:
                                                formatCUIT(
                                                    invoice.cuit
                                                ).replace(/\s/g, '') || '-',
                                        },
                                        {
                                            label: 'Fecha de ingreso',
                                            value: invoice.fecha_creacion
                                                ? getDate(
                                                      invoice.fecha_creacion
                                                  )
                                                      .split('-')
                                                      .reverse()
                                                      .join('/')
                                                : '--',
                                        },
                                        {
                                            label: 'Fecha de facturación',
                                            value: invoice.fecha_factura
                                                .split('-')
                                                .reverse()
                                                .join('/'),
                                        },
                                    ]}
                                />
                                <ScrollBox
                                    width="100%"
                                    height="calc(100% - 43px)"
                                >
                                    <span
                                        style="padding:32px 70px; gap: 14px; display: flex; flex-direction: column"
                                    >
                                        <FormBoxContainer
                                            title="Información de la Factura"
                                        >
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Identificador"
                                                    value={invoice.id_ath}
                                                />
                                                <FormBoxCell
                                                    label="Estado"
                                                    value={invoice.estado in
                                                        refStates &&
                                                    'label' in
                                                        refStates[
                                                            invoice.estado
                                                        ]
                                                        ? refStates[
                                                              invoice.estado
                                                          ].label
                                                        : invoice.estado}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Compañía"
                                                    value={company[
                                                        invoice.cuit_facturacion
                                                    ] || '...'}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Nro. de Comprobante"
                                                    value={invoice.nro_comprobante
                                                        ? invoice.nro_comprobante.padStart(
                                                              8,
                                                              '0'
                                                          )
                                                        : '...'}
                                                />
                                                <FormBoxCell
                                                    label="Punto de Venta"
                                                    value={invoice.punto_de_venta
                                                        ? invoice.punto_de_venta.padStart(
                                                              5,
                                                              '0'
                                                          )
                                                        : '...'}
                                                />
                                                <FormBoxCell
                                                    label="Tipo"
                                                    value={invoice.tipo_comprobante}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Importe Total"
                                                    value={invoice.importe_total
                                                        ? currencyFormatter({
                                                              n: invoice.importe_total,
                                                              lang: 'es-AR',
                                                              type: 'ARS',
                                                          })
                                                        : '...'}
                                                />
                                                <FormBoxCell
                                                    label="Moneda"
                                                    value={invoice.moneda}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Orden de Compra"
                                                    value={invoice.orden_de_compra.join(
                                                        ', '
                                                    ) || 'No'}
                                                />
                                            </FormBoxRow>
                                            {#if ENV.DEV}
                                                <FormBoxRow>
                                                    <FormBoxCell>
                                                        <a
                                                            href={`${siteUrl}/file/view/${params.id}`}
                                                            target="_blank"
                                                            >{`${siteUrl}/file/view/${params.id}`}</a
                                                        >
                                                    </FormBoxCell>
                                                </FormBoxRow>
                                            {/if}
                                        </FormBoxContainer>
                                        <Alert type="info"
                                            >En caso de duda, comunicarse con el
                                            área a la cual se brindó el
                                            servicio.</Alert
                                        >
                                        <span class="buttonSet">
                                            <Button
                                                type="secondary"
                                                on:click={(_) => {
                                                    window.open(
                                                        'https://www.cobranzas.com/',
                                                        '_blank'
                                                    )
                                                }}
                                                label="Cobranzas.com"
                                            />
                                            <Button
                                                label="Descargar"
                                                style="width: 100%"
                                                on:click={(_) =>
                                                    window.open(invoice.link)}
                                            />
                                        </span>
                                    </span>
                                </ScrollBox>
                            </div>
                        {:catch}
                            <Alert type="error"
                                >La factura no existe o no tienes permisos para
                                verla.</Alert
                            >
                        {/await}
                    </TopBar>
                </div>
            </BackDrop>
        </Route>
    </Router>
</div>

<style>
    .drawer {
        position: absolute;
        min-width: 500px;
        width: 100%;
        max-width: 978px;
        right: 0;
        top: 0;
        height: 100%;
        background-color: #f6f6f6;
    }
    .search {
        width: 100%;
        height: 72px;
        position: relative;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        padding: 0 25px;
        justify-content: flex-start;
    }
    .search input {
        border-style: none;
        outline: none;
        font-size: 17px;
        width: 100%;
    }

    .buttonSet {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
</style>
